export default __webpack_public_path__ + "static/media/Rubik-ExtraBold.4b8d194c.ttf";